/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ChevronRight = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.1853 12.25L8.70047 17.7346L9.76113 18.7953L15.2459 13.3106L16.2005 12.25L15.2459 11.1893L9.76098 5.7045L8.70032 6.76516L14.1853 12.25Z"
                        fill={color}
                    />
                </svg>
        );
    };
